module.exports = __webpack_public_path__ + "img/img-1.b5fe3bd5.png";